import React from "react";

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom";

import SectionHeader from "@/components/SectionHeader.component";
import { localizePath } from "@/utils/i18nRoutes";

import i18n from "../../i18n";

interface IPressRelease {
  date: Date;
  title: string;
  description: string;
  location: string;
  img: string;
  link: string;
}

const PressReleaseComponent = (): React.JSX.Element => {
  const { t, language } = i18n;
  const lang = language === "fr" ? "fr" : "en";

  const items: IPressRelease[] = [
    {
      date: new Date(2026, 9, 20),
      title: t("A Home Built from 200,000 Recycled Plastic Bottles"),
      description: t(
        "Québec cleantech company PakVille introduces a faster, more affordable way to build homes while reducing construction’s environmental footprint.",
      ),
      location: "Montréal, Québec",
      link: localizePath("/releases/2026-10-20", lang),
      img: "/images/press/20261020_Press_Release_Photo.png",
    },

    {
      date: new Date(2026, 4, 8),
      title: t(
        "Canadian Home Solution Builder Partners With National Foundation to Address Indigenous Housing Crisis",
      ),
      description: t(
        "PakVille and The Steven Low Foundation combine sustainable housing innovation with community-informed guidance to help deliver scalable, culturally respectful housing solutions for Indigenous communities across Canada.",
      ),
      location: "Montréal, Québec",
      link: localizePath("/releases/2026-05-08", lang),
      img: "/images/press/20260508_Press_Release_Photo.png",
    },
  ];

  return (
    <Container>
      <SectionHeader
        eyebrow={t("From PakVille™")}
        title={t("Press Releases")}
        description={t(
          "Official company announcements, project milestones and updates from PakVille™.",
        )}
      />
      <div className="pressReleaseGrid">
        {items.map((item) => (
          <Card
            key={item.title}
            as={Link}
            className="pressReleaseCard rounded p-1 text-decoration-none"
            to={item.link}
          >
            <Card.Header className="d-flex flex-column flex-lg-row mt-3 gap-4 border-0 bg-white">
              <div
                className="rounded d-flex"
                style={{
                  minWidth: "220px",
                  minHeight: "130px",
                  maxWidth: "220px",
                  maxHeight: "130px",
                }}
              >
                <Image
                  rounded
                  alt={item.title}
                  className="mw-100"
                  src={item.img}
                />
              </div>

              <Card.Title
                className="fs-4"
                style={{ color: "var(--primary-color)" }}
              >
                <div className="d-flex h6 sectionEyebrow gap-2 mb-3">
                  {item.date.toLocaleDateString(language, {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                  <div>-</div>
                  {item.location}
                </div>
                <div>{item.title}</div>
              </Card.Title>
            </Card.Header>

            <Card.Body className="m-0 pt-0">
              <Card.Text>{item.description}</Card.Text>
            </Card.Body>
            <Card.Footer
              className="d-flex align-items-center justify-content-between w-100 flex-wrap"
              style={{
                fontSize: "13px",
                background: "#FFF",
                border: "none",
              }}
            >
              {/* Visual cue only: the whole card is the link. */}
              <span
                aria-hidden="true"
                className="btn btn-sm btn-outline border-0 ps-4 pe-2"
                style={{ marginLeft: "-0.5rem" }}
              >
                {t("Read Press Release")}
                <FontAwesomeIcon className="ms-2" icon={faArrowRight} />
              </span>
            </Card.Footer>
          </Card>
        ))}
      </div>
    </Container>
  );
};

export default PressReleaseComponent;
